import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'sonner'
import { GoogleOAuthProvider } from '@react-oauth/google'
import './posthog'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || ""}>
      <App />
      <Toaster richColors position="top-right" closeButton />
    </GoogleOAuthProvider>
  </StrictMode>,
)

